import cn from 'classnames';
import readXlsxFile from 'read-excel-file';
import { showSuccessNotify } from '../../../../../utils/Notiffication';
import styles from './styles.module.scss';

const ImportExcelButton = ({
  width = 'default',
  height = '36px',
  style,
  onChange = (_) => _,
  redButton = false,
  children,
  ...props
}) => {
  const parseData = (file) => {
    readXlsxFile(file).then((rows) => {
      let keys = {};
      rows[0].forEach((item, key) => {
        keys[key] = item;
      }); // забираем наименование столбцов с шапки

      const data = rows.slice(1).map((d) => {
        const row = {};
        d.forEach((item, key) => {
          row[keys[key]] = item;
        });
        return row;
      });

      onChange(data);
      showSuccessNotify('Файл обработан');

    });
  };

  const onLoad = async (e) => {
    let file = e.target.files[0];
    parseData(file);
    e.target.value = null;
  };

  return (
    <label style={{ width, height, ...style }}>
      <span className={cn(styles.button_base, styles.button_green, redButton && styles.button_red, props.styles)}>
        {children}
      </span>
      <input type="file" className={styles.input} onChange={(e) => onLoad(e)} />
    </label>
  );
};

export default ImportExcelButton;
